import {designSystemToken} from '@lightricks/react-design-system';

export const calculatePhraseScore = (difference: number) => {
  const absoluteDifference = Math.abs(difference);
  const gradeMap: Record<number, {score: string; color: string}> = {
    0: {score: 'perfect!', color: designSystemToken('semantic.fg.success')},
    1: {score: 'good!', color: designSystemToken('semantic.fg.success')},
    2: {score: 'a bit too', color: designSystemToken('semantic.fg.warning')},
  };
  const defaultScore = {
    score: 'too',
    color: designSystemToken('semantic.fg.danger'),
  };
  const {score, color} = gradeMap[absoluteDifference] || defaultScore;
  let phrase = score;
  if (absoluteDifference > 1) {
    phrase = `${score} ${difference > 0 ? 'long' : 'short'}`;
  }
  return {phrase, color};
};

export const calculateLength = (text: string) => {
  return text
    .trim()
    .split(' ')
    .filter((word) => word.length > 0).length;
};
